import { render, staticRenderFns } from "./CreditsRecord.vue?vue&type=template&id=c93d877e&scoped=true"
import script from "./CreditsRecord.vue?vue&type=script&lang=js"
export * from "./CreditsRecord.vue?vue&type=script&lang=js"
import style0 from "./CreditsRecord.vue?vue&type=style&index=0&id=c93d877e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93d877e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c93d877e')) {
      api.createRecord('c93d877e', component.options)
    } else {
      api.reload('c93d877e', component.options)
    }
    module.hot.accept("./CreditsRecord.vue?vue&type=template&id=c93d877e&scoped=true", function () {
      api.rerender('c93d877e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CreditsRecord.vue"
export default component.exports